module.exports = __webpack_public_path__ + "img/7-icono-misordenes.54ac45d6.svg";